import styled from 'styled-components';

export const SafeCarouselContainer = styled.section`
  margin: 40px 0;

  @media (max-width: 720px) {
    margin: 10px 0;
  }
`;

export const USPcontainer = styled.div`
  background-image: url('https://images.myloapp.in/NestJsUploads/1697935932916-browndesktopwavetwo.webp');
  background-size: cover;
  position: relative !important;
  top: -1px;
  padding-top: 26%;

  @media (max-width: 720px) {
    padding-top: ${(props) => (props.isForNewCdPage ? '0' : '60%')};
  }

  span {
    max-width: 560px;
    margin: auto !important;
  }

  img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }

  @media (max-width: 720px) {
    background-image: url('https://images.myloapp.in/NestJsUploads/1697935932919-brown-wave-2.webp');
  }

  .carousel-arrows {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 80%;
    padding: 0 16px;
    top: 50%;
    transform: translateY(-50%);

    // Hide arrows on mobile
    @media (max-width: 720px) {
      display: none;
    }
  }

  .carousel-left-arrow,
  .carousel-right-arrow {
    cursor: pointer;
  }
`;

export const USPContent = styled.div`
  text-align: center;
  padding: 10px;
  text-align: center;
  padding: 10px;
  max-width: 600px;
  margin: 0 auto;

  h3 {
    font-size: 16px;
    color: #414141;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 87%);
    padding: 4px 0;
    height: 56px;

    @media (max-width: 720px) {
      height: 76px;
    }
  }
`;

export const USPImage = styled.img`
  width: 100%;
  height: 100%;
  max-width: 560px;
`;

export const CarouselContentDiv = styled.div`
  height: 100%;
  width: 100%;

  @media (max-width: 720px) {
    border-radius: 0;
    width: ${(props) => (props.testimonial ? '240px' : '100%')};
  }
`;

export const CarouselCSS = styled.div`
  background: #fff;
  position: relative;

  .image-gallery-bullets-container {
    text-align: center;
  }
  .image-gallery-slide {
    width: 100%;
    @media (max-width: 720px) {
      width: ${(props) => (props.isForNewCdPage ? '100%' : '91%')};
    }
  }
  .image-gallery-slides {
    white-space: normal !important;
    line-height: normal !important;
    width: 100%;
  }
  .image-gallery-content {
    line-height: normal !important;
  }
  .image-gallery-bullet {
    width: 12px;
    height: 12px;
    background-color: #00000066;
    border: none;
    border-radius: 50%;
    margin: 0 4px;
    transition: all 0.3s ease;

    @media (min-width: 768px) {
      cursor: pointer;
    }

    &.active {
      background-color: #ef4e5e;
      width: 20px;
      border-radius: 10px;
    }
  }
`;
